import * as React from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { maxLength, required, Validators } from '../../../../../components/redux-form/utils/validators';
import { FormError } from '../../../../../components/redux-form/FormError';
import { FieldInput } from '../../../../../components/redux-form/fields/FieldInput';
import { asyncAuthCodeCustomerLogin } from '../../../../../store/actions/auth-actions';
import Button from '../../../../../components/Button';
import styles from '../assets/login-form.module.scss';
import classNames from 'classnames';

export interface LoginAuthCodeFormData {
    authCode: string;
}

export interface LoginAuthCodeFormProps {
    isCode: boolean;
}

type InjectedProps = InjectedFormProps<LoginAuthCodeFormData, LoginAuthCodeFormProps>;

const validators: Validators<LoginAuthCodeFormData> = {
    authCode: [required({ message: 'Enter the code please' }), maxLength({ max: 255 })],
};

const LoginAuthCodeForm: React.FunctionComponent<InjectedProps & LoginAuthCodeFormProps> = ({
    error,
    handleSubmit,
    submitting,
}: InjectedProps & LoginAuthCodeFormProps) => (
    <form onSubmit={handleSubmit}>
        <div className={classNames(styles.login)}>
            <FieldInput
                name="authCode"
                type="text"
                validate={validators.authCode}
                inputStyle={classNames(styles.blueBorder, 'form-control')}
                wrapperConfig={{
                    label: 'Please, enter the code received in SMS',
                }}
            />
            <div style={{ textAlign: 'center' }}>
                <FormError error={error} />
            </div>
        </div>
        <div className={classNames('text-center')}>
            <Button type="submit" className={`${classNames(styles.button)} ${'btn btn-success'}`} disabled={submitting}>
                Login
            </Button>
        </div>
    </form>
);

export default reduxForm<LoginAuthCodeFormData, LoginAuthCodeFormProps>({
    form: 'customer-login',
    onSubmit: asyncAuthCodeCustomerLogin,
})(LoginAuthCodeForm);
